import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { OWNERSHIP_CHANGE_PACKET } from "./apiRoutes";

interface UseGetOwnershipChangePacketByIdProps {
  ocpId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getOwnershipChangePacketById = async (ocpId: string) =>
  await axiosAuth.get(`${OWNERSHIP_CHANGE_PACKET}/${ocpId}`);

const useGetOwnershipChangePacketById = ({
  ocpId,
  queryParams,
}: UseGetOwnershipChangePacketByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["ownership-change-packet", ocpId],
    queryFn: () => getOwnershipChangePacketById(ocpId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!ocpId && (queryParams?.enabled ?? true),
  });
};

export default useGetOwnershipChangePacketById;
